import React from 'react'
import ReservationConfigurationInitialize from '../ReservationConfigurationInitialize'
import Routes from './Routes'
import _ from 'lodash'
import ReservationDialog from '../ReservationDialog'
import BarcodeToastMessage from '../BarcodeToastMessage'

function ReservationConfigurationMain({children}) {
  return (
    <ReservationConfigurationInitialize>
      <BarcodeToastMessage />
      <ReservationDialog />
      <Routes />
    </ReservationConfigurationInitialize>
  )
}

export default ReservationConfigurationMain
